import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as ProRegularIcons from "@fortawesome/pro-regular-svg-icons";
import * as ProSolidIcons from "@fortawesome/pro-solid-svg-icons";

export default function ChatTagBadges({ bookingId }) {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (bookingId) {
            fetchTags();
        }
    }, [bookingId]);

    const fetchTags = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}bookings/${bookingId}/chat-tags`
            );
            setTags(response.data || []);
        } catch (error) {
            console.error("Error fetching chat tags:", error);
            setTags([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading || tags.length === 0) {
        return null;
    }

    const getIconComponent = (iconName) => {
        if (!iconName) return null;
        
        // Convert icon name to camelCase format (e.g., "wrench" -> "faWrench")
        const camelCaseIcon = 'fa' + iconName.charAt(0).toUpperCase() + iconName.slice(1).replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        
        // Try to find icon in pro-regular first, then pro-solid
        const icon = ProRegularIcons[camelCaseIcon] || ProSolidIcons[camelCaseIcon];
        return icon;
    };

    return (
        <div className="flex items-center space-x-2">
            {tags.map((tag) => {
                const icon = getIconComponent(tag.icon);
                return (
                    <div
                        key={tag.id}
                        className="flex items-center justify-center h-10 w-10 rounded-full bg-blue-600 text-white text-xs font-medium shadow-sm"
                        title={tag.name}
                    >
                        {icon ? (
                            <FontAwesomeIcon icon={icon} className="h-5 w-5" />
                        ) : (
                            tag.name.substring(0, 2).toUpperCase()
                        )}
                    </div>
                );
            })}
        </div>
    );
}
